import { useState } from 'react';
import { Menu, X, LogIn, User } from 'lucide-react';
import { Link } from 'react-router-dom';
import { LK_URL } from '../config/links';

const navigation = [
  { name: 'Главная', href: '/' },
  { name: 'Чемпионат', href: '/about' },
  { name: 'Участникам', href: '/participants' },
  { name: 'FAQ', href: '/faq' },
  { name: 'Партнёры', href: '/partners' },
  { name: 'Новости', href: '/blog' },
  { name: 'Контакты', href: '/contacts' },
];

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <img src="/images/o4kilogo.png" alt="ОЧКИ" className="max-w-full h-auto w-48 md:w-32 lg:w-48" />
            <p className="text-xs text-gray-500 mt-1">Онлайн-чемпионат Югры по креативным индустриям</p>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-gray-700 hover:text-primary-600 font-medium transition-colors"
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center space-x-4">
            <a
              href={LK_URL}
              className="flex items-center space-x-2 text-gray-700 hover:text-primary-600"
            >
              <User size={18} />
              <span>Вход</span>
            </a>
            <Link
              to="/registration"
              className="btn-primary flex items-center space-x-2"
            >
              <LogIn size={18} />
              <span>Подать заявку</span>
            </Link>
          </div>

          <button
            type="button"
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6 text-gray-700" />
            ) : (
              <Menu className="h-6 w-6 text-gray-700" />
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-gray-700 hover:text-primary-600 py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <div className="pt-4 space-y-3">
                <a
                  href={LK_URL}
                  className="flex items-center space-x-2 text-gray-700 hover:text-primary-600"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <User size={18} />
                  <span>Вход в личный кабинет</span>
                </a>
                <Link
                  to="/registration"
                  className="btn-primary inline-flex items-center justify-center space-x-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <LogIn size={18} />
                  <span>Подать заявку</span>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}